import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { PageMenu } from '../../../../components'
import { IconPatrimonioBlue } from '../../../../assets/imgs'
import NotAllowedModule from '../../../../components/NotAllowedModule/NotAllowedModule'
import {
  menuItemsAllowed,
  TpPermissions,
  verifyTpPermission,
} from '../../../../services/permission/menus'

function PatrimonioMenu({ selectedTp }) {
  const [allowed, setAllowed] = React.useState(true)

  useEffect(() => {
    const allowed = verifyTpPermission(TpPermissions.PATRIMONIO, selectedTp)
    setAllowed(allowed)
  }, [selectedTp])

  const menuItems = menuItemsAllowed([
    {
      id: 27,
      content: { menu: '6.1 - Ativo Patrimonial', path: '/main/patrimonio/ativo' },
    },
    {
      id: 43,
      content: {
        menu: '6.2 - Movimentação - Recebimento',
        path: '/main/patrimonio/movimentacao-recebimento',
      },
    },
    {
      id: 103,
      content: {
        menu: '6.3 - Movimentação - Devolução',
        path: '/main/patrimonio/movimentacao-devolução',
      },
    },
    {
      id: 104,
      content: {
        menu: '6.4 - Movimentação - Last Mile',
        path: '/main/patrimonio/movimentacao-last-mile',
      },
    },
    {
      id: 29,
      content: {
        menu: '6.5 - Validação de Canhoto',
        path: '/main/patrimonio/validacao-canhoto',
      },
    },
    {
      id: 105,
      content: {
        menu: '6.6 - Saldo Patrimonial por Operação',
        path: '/main/patrimonio/saldo-por-operacao',
      },
    },
    {
      id: 106,
      content: {
        menu: '6.7 - Pendencias por Transportadora',
        path: '/main/patrimonio/pendencias-transportadora',
      },
    },
  ])

  return (
    <>
      <PageMenu menuItems={allowed ? menuItems : []}>
        <img src={IconPatrimonioBlue} alt="Icon Tela de Patrimonio" />
        <span style={{ display: 'inline-block', marginLeft: 10 }}>6. Patrimônio</span>
      </PageMenu>
      {!allowed && <NotAllowedModule />}
    </>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(PatrimonioMenu))
